import { render, staticRenderFns } from "./dish.vue?vue&type=template&id=18e61327&scoped=true&"
import script from "./dish.vue?vue&type=script&lang=js&"
export * from "./dish.vue?vue&type=script&lang=js&"
import style0 from "./dish.vue?vue&type=style&index=0&id=18e61327&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e61327",
  null
  
)

export default component.exports